import { Pagination } from "react-headless-pagination";
import { CgArrowLeft, CgArrowRight } from 'react-icons/cg'

const RowPagination = ({ currentPage, totalPages, setCurrentPage }) => {

    return(
        <>
          <div className="mt-10 pt-6 border-t mb-10">
    <Pagination
        currentPage={currentPage-1}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages} 
        edgePageCount={2}
        middlePagesSiblingCount={2}
        className="flex items-center gap-2 p-2"
        truncableText="..."
        truncableClassName="text-gray-500"
      >
        <Pagination.PrevButton className="px-4 py-2.5 border rounded-md hover:bg-gray-100 transition cursor-pointer">
          <CgArrowLeft />
        </Pagination.PrevButton>

        <div className="flex items-center justify-center flex-grow gap-2 list-none">
          <Pagination.PageButton
            activeClassName="bg-gray-950 text-white"
            inactiveClassName="bg-white text-gray-700 border-gray-300 hover:bg-gray-200"
            className="px-4 py-2 border rounded-md transition cursor-pointer"
          />
        </div>

        <Pagination.NextButton className="px-4 py-2.5 border rounded-md hover:bg-gray-100 transition  cursor-pointer">
          <CgArrowRight />
        </Pagination.NextButton>
      </Pagination>

    </div>
        </>
    )
}

export default RowPagination